{
  "title": "Wristpocket",
  "source": "Explorer's Guide to Wildemount",
  "levelAndSchool": "2nd-level conjuration (ritual) (dunamancy)",
  "level": 2,
  "castingTime": "1 action",
  "range": "Self",
  "components": "S",
  "duration": "Concentration, up to 1 hour",
  "description": [
    "You flick your wrist, causing one object in your hand to vanish. The object, which only you can be holding and can weigh no more than 5 pounds, is transported to an extradimensional space, where it remains for the duration.",
    "Until the spell ends, you can use your action to summon the object to your free hand, and you can use your action to return the object to the extradimensional space. An object still in the pocket plane when the spell ends appears in your space, at your feet."
  ],
  "spellLists": ["wizard"]
}
